export const RoutesPath = {
  // HOME: "/",
  HOME: "/",
  COMMODITY:'/commodity',
  TERMSANDCONDITION:'/termsandcondition',
  PRIVACYPOLICY:'/privacypolicy',
  REFUNDPOLICY:'/refundpolicy',
  CONTACTUS:'/contactus',
  COMMODITYMOBILEAPP:'/commoditymobileapp'
};
